import { Divider } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { DataGridFloatingActionToolbarBase, TextButton } from '@retail/components';
import { useAssortmentItemActions } from './store';

interface Props {
  totalItems: number;
  isUpdatePricesEnabled: boolean;
}

export function AssortmentItemsActionToolbar({ totalItems, isUpdatePricesEnabled }: Props) {
  const t = useMyAssortmentTFunction();
  const {
    itemsChecked,
    checkItems,
    setItemsForDeletion,
    toggleBulkEditPrices,
    toggleBulkEditPriorities,
    toggleBulkEditTags,
  } = useAssortmentItemActions();

  return (
    <DataGridFloatingActionToolbarBase
      totalItems={totalItems}
      itemsChecked={itemsChecked.length}
      resetChecked={() => checkItems([])}
      actions={
        <>
          {isUpdatePricesEnabled && (
            <>
              <Divider orientation="vertical" sx={{ height: 'auto' }} />
              <TextButton
                sx={{ ':hover': { color: 'common.black' } }}
                onClick={() => toggleBulkEditPrices(true)}
              >
                {t('myAssortment.actions.bulkEditPrices')}
              </TextButton>
            </>
          )}

          {toggleBulkEditPriorities && (
            <>
              <Divider orientation="vertical" sx={{ height: 'auto' }} />
              <TextButton
                sx={{ ':hover': { color: 'common.black' } }}
                onClick={() => toggleBulkEditPriorities(true)}
              >
                {t('myAssortment.actions.bulkEditItems')}
              </TextButton>
            </>
          )}

          <Divider orientation="vertical" sx={{ height: 'auto' }} />
          <TextButton
            sx={{ ':hover': { color: 'common.black' } }}
            onClick={() => toggleBulkEditTags(true)}
          >
            {t('myAssortment.actions.editTags')}
          </TextButton>

          <Divider orientation="vertical" sx={{ height: 'auto' }} />

          <TextButton
            disabled={!itemsChecked}
            onClick={setItemsForDeletion}
            sx={{ ':hover': { color: 'common.black' } }}
          >
            {t('myAssortment.actions.deleteItems')}
          </TextButton>
        </>
      }
    />
  );
}
